import type { SoundClipsLocale } from './en'

export const soundClipsTeIn = {
  list: {
    title: 'సౌండ్ క్లిప్‌లు',
    loading: 'సౌండ్ క్లిప్‌లను లోడ్ చేస్తోంది...',
    error: 'లోపం',
    empty: 'సౌండ్ క్లిప్‌లు కనుగొనబడలేదు',
    emptyDescription:
      'ప్రస్తుతం ఈ PBX కోసం సౌండ్ క్లిప్‌లు ఏవీ కాన్ఫిగర్ చేయబడలేదు.',
    noResults: 'ఫలితాలు లేవు',
    noResultsDescription: 'మీ శోధనకు సరిపోలే సౌండ్ క్లిప్‌లు లేవు.',
    columnName: 'పేరు',
    columnFeatureCode: 'ఫీచర్ కోడ్',
    columnUpdated: 'అప్‌డేట్ చేయబడింది',
    columnActions: 'చర్యలు',
    featureCodeNone: 'N/A',
    createButton: '+ కొత్త సౌండ్ క్లిప్',
    deleteConfirmTitle: 'సౌండ్ క్లిప్‌ను తొలగించండి',
    deleteConfirmMessage:
      'మీరు ఖచ్చితంగా "{{name}}"ను తొలగించాలనుకుంటున్నారా? ఈ చర్యను రద్దు చేయడం సాధ్యం కాదు.',
    deleteConfirmButton: 'తొలగించండి',
    deleteSuccess: 'సౌండ్ క్లిప్ తొలగించబడింది.',
    deleteError: 'సౌండ్ క్లిప్‌ను తొలగించడంలో విఫలమైంది.',
    searchPlaceholder: 'సౌండ్ క్లిప్‌లను శోధించండి...',
    recordingInfo:
      'కొత్త సౌండ్ క్లిప్‌ను రికార్డ్ చేయడానికి మీ ఫోన్ నుండి *99 డయల్ చేయండి. ఇప్పటికే ఉన్న క్లిప్‌ను మళ్లీ రికార్డ్ చేయడానికి *100–*109 డయల్ చేయండి.',
    audioLoadError:
      'ఆడియోను లోడ్ చేయలేకపోయాము — దీన్ని మళ్లీ రికార్డ్ చేయాల్సి రావచ్చు.',
  },
  create: {
    title: 'కొత్త సౌండ్ క్లిప్',
    nameLabel: 'పేరు',
    namePlaceholder: 'సౌండ్ క్లిప్ పేరును నమోదు చేయండి',
    featureCodeLabel: 'ఫీచర్ కోడ్',
    featureCodeNone: 'ఏదీ లేదు',
    audioFileLabel: 'ఆడియో ఫైల్',
    audioFilePlaceholder:
      'WAV లేదా MP3 ఫైల్‌ను ఇక్కడ లాగి వదలండి, లేదా బ్రౌజ్ చేయడానికి క్లిక్ చేయండి',
    audioFileAccepted: 'WAV, MP3 (గరిష్టంగా 25 MB)',
    cancel: 'రద్దు చేయండి',
    submit: 'సౌండ్ క్లిప్‌ను అప్‌లోడ్ చేయండి',
    creating: 'అప్‌లోడ్ చేస్తోంది...',
    success: 'సౌండ్ క్లిప్ విజయవంతంగా సృష్టించబడింది.',
    error: 'సౌండ్ క్లిప్‌ను సృష్టించడంలో విఫలమైంది.',
    nameRequired: 'పేరు తప్పనిసరి.',
    audioFileRequired: 'ఆడియో ఫైల్ అవసరం.',
  },
  edit: {
    title: 'సౌండ్ క్లిప్‌ను సవరించండి',
    loading: 'సౌండ్ క్లిప్‌ను లోడ్ చేస్తోంది...',
    notFound: 'సౌండ్ క్లిప్ కనుగొనబడలేదు.',
    backToList: '← జాబితాకు తిరిగి వెళ్లండి',
    nameLabel: 'పేరు',
    namePlaceholder: 'సౌండ్ క్లిప్ పేరును నమోదు చేయండి',
    featureCodeLabel: 'ఫీచర్ కోడ్',
    featureCodeNone: 'ఏదీ లేదు',
    audioFileLabel: 'ఆడియో ఫైల్‌ను భర్తీ చేయండి',
    audioFilePlaceholder:
      'భర్తీ చేయడానికి కొత్త ఫైల్‌ను లాగి వదలండి, లేదా బ్రౌజ్ చేయడానికి క్లిక్ చేయండి',
    audioFileAccepted: 'WAV, MP3 (గరిష్టంగా 25 MB)',
    currentAudio: 'ప్రస్తుత ఆడియో',
    playCurrentAudio: 'ప్రస్తుత ఆడియోను ప్లే చేయండి',
    stopAudio: 'ఆపండి',
    audioLoadError:
      'ఈ క్లిప్ ఆడియోను లోడ్ చేయలేకపోయాము — దీన్ని మళ్లీ రికార్డ్ చేయాల్సి రావచ్చు.',
    createdLabel: 'సృష్టించబడింది',
    updatedLabel: 'చివరి అప్‌డేట్',
    cancel: 'రద్దు చేయండి',
    submit: 'మార్పులను సేవ్ చేయండి',
    saving: 'సేవ్ చేస్తోంది...',
    success: 'సౌండ్ క్లిప్ విజయవంతంగా అప్‌డేట్ చేయబడింది.',
    error: 'సౌండ్ క్లిప్‌ను అప్‌డేట్ చేయడంలో విఫలమైంది.',
    deleteButton: 'సౌండ్ క్లిప్‌ను తొలగించండి',
  },
  upload: {
    invalidType: 'మద్దతు లేని ఫైల్ రకం. దయచేసి WAV లేదా MP3 అప్‌లోడ్ చేయండి.',
    tooLarge: 'ఫైల్ చాలా పెద్దది. గరిష్ట పరిమాణం 25 MB.',
  },
} satisfies SoundClipsLocale
